/* tslint:disable:no-shadowed-variable prefer-const */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ForestDto, ForestProductDto } from '@system-shared/classes.dto';

@Injectable()
export class ForestsService {
  private endpoint = environment.apiUrl + 'forests/';

  constructor(private http: HttpClient) {}

  /**
   * @returns all forests
   */
  getAll(): Observable<ForestDto[]> {
    return this.http.get<ForestDto[]>(this.endpoint);
  }

  getAllByAdmin(): Observable<ForestDto[]> {
    return this.http.get<ForestDto[]>(this.endpoint + 'admin', { withCredentials: true});
  }

  /**
   * @returns forest by id
   */
  getOne(forestCode): Observable<ForestDto> {
    return this.http.get<ForestDto>(this.endpoint + forestCode);
  }

  getForestProduct(id, product): Observable<ForestProductDto> {
    return this.http.get<ForestProductDto>(this.endpoint + `${id}/products/${product}`)
  }

  saveForestActiveStatus(forests: ForestDto[]): Observable<ForestDto[]> {
    return this.http.post<ForestDto[]>(this.endpoint, forests, { withCredentials: true });
  }

  updateForest(forestCode: string, updatedData: ForestDto): Observable<ForestDto> {
    return this.http.put<ForestDto>(this.endpoint + forestCode, updatedData, { withCredentials: true });
  }
}
